module.exports = __webpack_public_path__ + "static/img/partner_35.0df7453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_35.png
// module id = ycxR
// module chunks = 0